/** @jsx jsx */
import { jsx } from '@emotion/react';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';

import type { ResponseData } from '../useAlertBanner/useAlertBannerData';

import { BannerProps } from './types';

import { useUniversalNavContext } from '../../../../universal-nav/hooks';

export const shouldRender = (data: ResponseData) => {
  const { isEnterpriseAccount, enterpriseTrialEndDate } = data.currentAccount;

  if (!enterpriseTrialEndDate || isEnterpriseAccount) return false;

  const enterpriseTrialHasEnded =
    parseDateTime(enterpriseTrialEndDate) < new Date();
  return enterpriseTrialHasEnded && daysFromNow(enterpriseTrialEndDate) <= 7;
};

export const Component = function EnterpriseTrialEnded(props: BannerProps) {
  const { getFullyQualifiedURL } = useUniversalNavContext();

  const { data } = props;

  const onContactSalesClick = () => {
    props.trackEvent('enterprise-trial-ended-contact-sales-clicked', {
      profileId: data.currentUser.customUserId,
    });
  };

  return (
    <Alert
      layout={props.layout}
      title="Your Enterprise trial has ended"
      type="info"
    >
      <Link
        href={getFullyQualifiedURL(
          '/l/contact-sales?demo_source=enterprise-trial-ended-banner-logged-in'
        )}
        onClick={onContactSalesClick}
      >
        Contact Sales
      </Link>{' '}
      to keep using our advanced administrative and security controls.
    </Alert>
  );
};
